(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["accordion-with-image"] && !Shopify.designMode) return;
  try {
    
  /* No section-scoped JS; minimal inline script is gated by setting */

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cards-grid"] && !Shopify.designMode) return;
  try {
    
  /* No JS needed currently */

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["content-with-image"] && !Shopify.designMode) return;
  try {
    
  /* Kein zusätzliches Section-JS erforderlich */

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["headline-with-embed"] && !Shopify.designMode) return;
  try {
    
  /* Kein zusätzliches JS erforderlich. */

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["help-cta-fixed"] && !Shopify.designMode) return;
  try {
    
    /* No JS required for this fixed CTA. */
  
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["stats-with-cta"] && !Shopify.designMode) return;
  try {
    
  /* Kein zusätzliches Section-JS erforderlich; Inline-Script oben reicht. */

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["testimonials-marquee"] && !Shopify.designMode) return;
  try {
    
  /* Kein JS erforderlich – CSS-only Marquee */

  } catch(e) { console.error(e); }
})();
})();
